// extracted by mini-css-extract-plugin
export default {"typeUiSeparatorLineTypeContinuousSize2Px":"PlasmicSeparatorVertical_typeUiSeparatorLineTypeContinuousSize2Px__wg14k"};